module.exports = __webpack_public_path__ + "img/1440.4a57f025.jpg";